import axios from "axios";

import { setupInterceptorsTo } from "./interceptors";

// Same interceptors as privateApi (correlation id + mixpanel context/distinct-id
// headers, so auth events stitch to the same user) but WITHOUT the 401 ->
// force-logout/redirect handler: a bad-credentials 401 on login must surface as
// an error to the caller, not nuke localStorage and bounce to /login.
const auth_api = setupInterceptorsTo(
  axios.create({
    baseURL: import.meta.env.VITE_APP_BACKEND_URL,
    headers: {
      "Content-Type": "application/json",
    },
  }),
  { redirectOn401: false },
);

export default auth_api;
